<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_v">Contents</a></p><a id="page_v">
</a><p class="toc"><a id="page_v"></a><a href="#/html/9780226187396_04_ill#lot">LIST OF ILLUSTRATIONS</a></p>
<p class="tocb"><a href="#/html/9780226187396_05_int#int">INTRODUCTION</a></p>
<p class="toc"><a href="#/html/9780226187396_06_ch1#ch1"><em>1. Muscadins</em></a></p>
<p class="toc"><span href="#/html/9780226187396_07_ch2#ch2" title="Link target outside of Sample"><em>2. Jeunes gens</em></span></p>
<p class="toc"><span href="#/html/9780226187396_08_ch3#ch3" title="Link target outside of Sample"><em>3. Incroyables</em></span></p>
<p class="toc"><span href="#/html/9780226187396_09_ch4#ch4" title="Link target outside of Sample"><em>4. Currutacos</em></span></p>
<p class="toc"><span href="#/html/9780226187396_10_ch5#ch5" title="Link target outside of Sample"><em>5. Crops</em></span></p>
<p class="tocb"><span href="#/html/9780226187396_11_epi#epi" title="Link target outside of Sample"><em>Epilogue</em></span></p>
<p class="toc"><span href="#/html/9780226187396_12_ack#ack" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="toc"><span href="#/html/9780226187396_13_lis#loa" title="Link target outside of Sample">LIST OF ABBREVIATIONS</span></p>
<p class="toc"><span href="#/html/9780226187396_14_not#not" title="Link target outside of Sample">NOTES</span></p>
<p class="toc"><span href="#/html/9780226187396_15_ind#ind" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226187396_03_toc.vue?53eaf39a